module.exports = __webpack_public_path__ + "static/media/station_broken.185f8b38.png";